// Modules
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { AdSupportCatApi } from "_Route/Api";


const AdDevSupportSvcDt = () => {

  // Using Hooks
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const useGroup = ['미사용', '사용'];

  const curType = params.id === 'add' ? {name: '등록', method: 'POST'} : {name: '수정', method: 'PUT'};
  const curScore = params.id === 'add' ? 200 : 300;

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);
  // const userRoles = useSelector(state => state.authorityAcc.roles);

  const [info, setInfo] = useState({
    ...(curType.name === '수정' && { reqcat_uuid: '' }),
    request_cat: '',
    reqcat_email: '',
    reqcat_use: 1,
    approve_spec_status: 0,
    approve_ap_status: 0,
  })
  const { request_cat, reqcat_email, reqcat_use } = info;

  const curDate = moment(new Date()).format('YYYY-MM-DD HH:mm');


  /*========================================================================
  * Input onChange Func
  ========================================================================*/
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }


  /*========================================================================
  * Set Current cust List
  ========================================================================*/
  useEffect(() => {
    axios({
      url: AdSupportCatApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      // console.log(res, "Service List GET Success!")
      const r = res.data.result;
      const curService = r.find(key => key.reqcat_uuid === params.id)

      if(curService === undefined && params.id !== 'add') {
        navigate('/404');
      }
      else {
        if (curType.name === '수정') {
          Object.entries(curService).map(key => {
            if(Object.keys(info).includes(key[0])) {
              info[key[0]] = key[1]
            }
          })
          setInfo({...info})
        }
      }
    })
    .catch(err => {
      console.error(err, "Service List GET Error...");
    })
  }, [location])


  /*========================================================================
  * Service Axios (POST, PUT, DELETE)
  ========================================================================*/
  const axiosSvc = (curName, curMethod) => {
    axios({
      url: AdSupportCatApi,
      method: curMethod,
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: curName === '삭제' ? { reqcat_uuid: params.id, approve_spec_status: 0, approve_ap_status: 0, } : info
    })
    .then(res => {
      // console.log(res, `Dev Support Service List ${curMethod} Success!`)
      alert(`서비스 ${curName}${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/dev-support/service-list')
    })
    .catch(err => {
      // alert(err.response.data.result)
      console.error(err, `Dev Support Service List ${curMethod} Error..`)
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }


  return (
    <>
      <div className="adContTitGroup">
        <h2>서비스 {curType.name}</h2>
        <p>Home / Dev Support / 서비스 {curType.name}</p>
      </div>

      <div className="adContArea detail">
        <fieldset className="left">
          <legend>서비스 등록 및 수정</legend>

          {/* 사용여부 [news_use] */}
          <div className="fieldGroup row">
            <label>사용여부<span className="redTxt">*</span></label>

            <div className="field">
              {useGroup.map((item, i) =>
                <div className="checkGroup" key={i}>
                  <input type="radio" className="check sm blue" name="reqcat_use" id={`reqcat_use_${i}`} value={i} onChange={(e) => onChange(e)} checked={Number(reqcat_use) === i}/>
                  <label htmlFor={`reqcat_use_${i}`}></label>

                  <label htmlFor={`reqcat_use_${i}`}>{item}</label>
                </div>
              )}
            </div>
          </div>

          {/* 서비스 명 [request_cat] */}
          <div className="fieldGroup row">
            <label>서비스 명<span className="redTxt">*</span></label>

            <div className="field">
              <input type="text" className="input md round_10" name="request_cat" onChange={(e) => onChange(e)} value={request_cat} placeholder="서비스 명을 입력해주세요." />
            </div>
          </div>

          {/* 담당자 이메일 [reqcat_email] */}
          <div className="fieldGroup row">
            <label>담당자 이메일<span className="redTxt">*</span></label>

            <div className="field">
              <input type="email" className="input md round_10" name="reqcat_email" onChange={(e) => onChange(e)} value={reqcat_email} placeholder="담당자 이메일을 입력해주세요." />
            </div>
          </div>

          {/* 등록 일시 */}
          <div className="fieldGroup row">
            <label>등록 일시</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={curDate} disabled />
            </div>
          </div>
        </fieldset>

        <div className="btnArea">
          {
            userScore >= curScore &&
            <button type="button" className="btn sm sfrtBlue round_10" onClick={() => axiosSvc(curType.name, curType.method)}>{curType.name}{master === 1 ? '' : ' 요청'}</button>
          }
          <button type="button" className="btn sm blue_edge round_10" onClick={() => navigate('/admin/dev-support/service-list')}>취소</button>
          {curType.name === '수정' && userScore >= 300 && <button type="button" className="btn sm red round_10" onClick={() => {if(window.confirm(`정말 해당 서비스를 삭제하시겠습니까?`)) axiosSvc('삭제', 'DELETE') }}>{`삭제${master === 1 ? '' : ' 요청'}`}</button>}
        </div>
      </div>
    </>
  )
}

export default AdDevSupportSvcDt;